import React, { useCallback, useState } from "react";
import { Button } from "@mui/material";

import MuPowerArchitectureModal from "fond/project/panels/MuPower/architecture/MuPowerArchitectureModal";
import MuPowerArchitectureSummary from "fond/project/panels/MuPower/architecture/MuPowerArchitectureSummary";
import { usePowerArchitecture } from "fond/project/panels/MuPower/architecture/usePowerArchitecture";
import { SystemOfMeasurement } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";

interface MuPowerArchitecturePanelProps {
  systemOfMeasurement: SystemOfMeasurement;
  isReadOnly: boolean;
}

const MuPowerArchitecturePanel: React.FC<MuPowerArchitecturePanelProps> = ({ systemOfMeasurement, isReadOnly }) => {
  const versionId = useAppSelector((state) => state.project.versionId);
  const { powerArchitecture, updatePowerArchitecture } = usePowerArchitecture(versionId);

  const [open, setOpen] = useState<boolean>(false);
  const onClickHandler = useCallback(() => setOpen(true), []);
  const onCloseHandler = useCallback(() => setOpen(false), []);

  return (
    <>
      {open && updatePowerArchitecture && (
        <MuPowerArchitectureModal
          powerArchitecture={powerArchitecture}
          systemOfMeasurement={systemOfMeasurement}
          onClose={onCloseHandler}
          onSave={updatePowerArchitecture}
        />
      )}
      <MuPowerArchitectureSummary systemOfMeasurement={systemOfMeasurement} powerArchitecture={powerArchitecture} />
      <Button
        fullWidth
        variant="contained"
        color="primary"
        data-testid="select-mu-power-architecture-button"
        className="select-mu-power-architecture-button"
        style={{ marginTop: "0.5em" }}
        onClick={onClickHandler}
        disabled={isReadOnly || !updatePowerArchitecture}
      >
        {powerArchitecture ? "Change architecture" : "Select architecture"}
      </Button>
    </>
  );
};

export default MuPowerArchitecturePanel;
